'use strict';

var module = angular.module('doclr.components.agenda');

module.directive('agendaContext', function () {
    return {
        require: 'agendaContext',
        controller: function ($scope, $timeout, agendaContextService, TimeChangedNotifier) {
            this.clickedInSlice = agendaContextService.clickedInSlice;
            this.clickedOnEvent = agendaContextService.clickedOnEvent;
            this.dblClickedOnEvent = agendaContextService.dblClickedOnEvent;
            this.activateProfile = agendaContextService.activateProfile;
            this.restoreDefaultProfile = agendaContextService.restoreDefaultProfile;
            this.getDefaultProfile = agendaContextService.getDefaultProfile;
            this.getActiveProfile = agendaContextService.getActiveProfile;
            this.isEventInFocus = agendaContextService.isEventInFocus;
            var timeChangedNotifier = new TimeChangedNotifier($scope);
            this.addTimeChangedListener = timeChangedNotifier.addTimeChangedListener;

            this.alternativeControlsLinkFn = null;
            this.extraControlsLinkFn = null;
        },
        link: function (scope, element, attrs, agendaContextCtrl) {
            var options = scope.$eval(attrs.agendaContext);
            agendaContextCtrl.agendas = options.agendas;
        }
    };
});

module.directive('jqdatepickerInput', function ($translate) {
    return {
        require: 'ngModel',
        link: function ($scope, $element, $attrs, ngModelCtrl) {
            var currentLanguage = doclrVertaal.getShortLanguageToUse($translate.use());

            var newRegionalSettings = Object.assign({}, $.datepicker.regional[currentLanguage]);
            delete newRegionalSettings.dateFormat;

            var datepickerOptions = Object.assign({}, {
                //  showAnim: '', // disable animation
                dateFormat: 'dd-mm-yy',
                onSelect: function (date) {
                    $scope.$apply(function () {
                        ngModelCtrl.$setViewValue(date);
                    });
                    $element.blur();
                },
                beforeShowDay: function (date) {
                    var isPast = date < moment().startOf('day').toDate();
                    return [true, isPast ? 'ui-datepicker-past-day' : ''];
                }
            }, newRegionalSettings);

            if ($attrs.minDate) {
                datepickerOptions.minDate = $scope.$eval($attrs.minDate);
            }

            $element.datepicker(datepickerOptions);
            $scope.$on('$destroy', function () {
                $element.datepicker('destroy');
            });
        }
    };
});

module.directive('jqdatepicker', function ($translate) {
    return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
            onDagChanged: '&',
            dag: '=ngModel',
            minDate: '=',
            maxDate: '=',
            dateFormat: '='
        },
        link: function ($scope, $element) {
            $(function () {
                var currentLanguage = doclrVertaal.getShortLanguageToUse($translate.use());
                $element.datepicker(Object.assign({}, {
                    showAnim: '', // disable animation
                    dateFormat: $scope.dateFormat || 'yy-mm-dd',
                    onSelect: function (dag) {
                        $scope.$apply(function () {
                            $scope.dag = dag;
                            $scope.onDagChanged({dag: $scope.dag});
                        });
                    },
                    minDate: $scope.minDate.toDate(),
                    maxDate: $scope.maxDate.toDate()
                }, $.datepicker.regional[currentLanguage]));

                $scope.$on('$destroy', function () {
                    $element.datepicker('destroy');
                });

                $scope.$watch('dag', function (newValue) {
                    $element.datepicker('setDate', newValue);
                });
            });
        }
    };
});

module.directive('jqweekpicker', function ($translate) {
    return {
        restrict: 'A',
        scope: {
            onDagChanged: '&',
            dag: '=ngModel',
            minDate: '=',
            maxDate: '=',
            dateFormat: '='
        },
        link: function ($scope, $element) {
            $(function () {
                var currentLanguage = doclrVertaal.getShortLanguageToUse($translate.use());
                $element.datepicker(Object.assign({}, {
                    showAnim: '', // disable animation
                    dateFormat: $scope.dateFormat || 'yy-mm-dd',
                    onSelect: function (dag) {
                        $scope.$apply(function () {
                            $scope.dag = moment(dag).weekday(0).format('YYYY-MM-DD');
                            $scope.onDagChanged({dag: $scope.dag});
                        });
                    },
                    beforeShowDay: function (date) {
                        var cssClass = '';
                        var selectedDate = $(this).datepicker('getDate');
                        var day = moment(date);
                        var startDate = moment(selectedDate).weekday(0);
                        var endDate = moment(selectedDate).weekday(6);
                        if ((day.isAfter(startDate, 'day') || day.isSame(startDate, 'day')) &&
                            (day.isBefore(endDate, 'day') || day.isSame(endDate, 'day'))) {
                            cssClass = 'ui-datepicker-current-day';
                        }
                        return [true, cssClass];
                    },
                    minDate: $scope.minDate.toDate(),
                    maxDate: $scope.maxDate.toDate()
                }, $.datepicker.regional[currentLanguage]));

                $element.on('mouseenter', '.ui-datepicker tr', function () {
                    $(this).find('td').addClass('ui-date-picker-hover-day').find('a').addClass('ui-state-hover');
                });
                $element.on('mouseleave', '.ui-datepicker tr', function () {
                    $(this).find('td').removeClass('ui-date-picker-hover-day').find('a').removeClass('ui-state-hover');
                });

                $scope.$on('$destroy', function () {
                    $element.off('mouseenter', '.ui-datepicker tr');
                    $element.off('mouseleave', '.ui-datepicker tr');
                    $element.datepicker('destroy');
                });

                $scope.$watch('dag', function (newValue) {
                    $element.datepicker('setDate', newValue);
                });
            });
        }
    };
});


module.directive('raster', function (agendaDimensions, rasterService) {
    return {
        restrict: 'A',
        scope: {
            onRasterClicked: '&',
            maskOnHover: '='
        },
        link: function (scope, element, attrs) {
            scope.rasterService = rasterService;

            var outerDiv = element.append('<div></div>').children();

            _.range(0, 24).forEach(function (uur) {
                var hourDiv = outerDiv.append('<div></div>').children().last()
                    .addClass('agenda-dag-uur')
                    .addClass('agenda-dag-uur-' + uur)
                    .height(agendaDimensions.uurHoogte);

                if (attrs.hasOwnProperty('withUurLabels')) {
                    hourDiv.append('<div></div>').children().last()
                        .addClass('agenda-dag-uur-label')
                        .text(uur + ':00');
                }

                agendaDimensions.hourDivisions.forEach(function (hourDivision) {
                    hourDiv.append('<div></div>').children().last()
                        .addClass('agenda-dag-uur-division')
                        .css('height', agendaDimensions.uurHoogte / agendaDimensions.hourDivisions.length)
                        .on('click', function (event) {
                            scope.onRasterClicked({
                                uur: moment({hour: uur}).add(hourDivision, 'minutes').format('HH:mm'),
                                event: event
                            });
                        });
                });

            });

            scope.$watch('maskOnHover', function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }

                if (newValue) {
                    element.find('.agenda-dag-uur-division').addClass('agenda-dag-uur-division-mask-on-hover');
                } else {
                    element.find('.agenda-dag-uur-division').removeClass('agenda-dag-uur-division-mask-on-hover');
                }
            });

            scope.$watchGroup(['rasterService.getStartUur()', 'rasterService.getEindUur()'], function () {
                var weerTeGevenUren = _.range(rasterService.getStartUur(), rasterService.getEindUur());

                element.find('.agenda-dag-uur').hide();

                weerTeGevenUren.forEach(function (uur) {
                    element.find('.agenda-dag-uur-' + uur).show();
                });

                function markLastVisibleDivisionPerDay(root = document) {
                    // Clear previous marks inside each day cell
                    root.querySelectorAll('td .agenda-dag-uur-division.is-last-visible-division')
                        .forEach(el => el.classList.remove('is-last-visible-division'));

                    // For each day cell, mark its last visible division
                    root.querySelectorAll('td').forEach(dayCell => {
                        const rows = Array.from(dayCell.querySelectorAll('.agenda-dag-uur'));

                        const visibleRows = rows.filter(row => {
                            const cs = getComputedStyle(row);
                            return cs.display !== 'none' && cs.visibility !== 'hidden';
                        });

                        const lastRow = visibleRows.at(-1);
                        if (!lastRow) return;

                        const lastDivision = lastRow.querySelector('.agenda-dag-uur-division:last-child');
                        if (lastDivision) lastDivision.classList.add('is-last-visible-division');
                    });
                }

                markLastVisibleDivisionPerDay(element[0].closest('table') || element[0]);
            });
        }
    };
});

module.directive('slice', function () {
    return {
        require: '^agendaContext',
        restrict: 'A',
        templateUrl: '/partials/components/slice.html',
        scope: {
            slice: '=',
            van: '=',
            tot: '='
        },
        transclude: true,
        link: function (scope, element, attrs, agendaContextCtrl) {
            var time;

            scope.clickedInSlice = agendaContextCtrl.clickedInSlice;
            scope.maskOnHover = function () {
                return agendaContextCtrl.getActiveProfile().maskOnHover;
            };

            scope.isCurrentDay = function () {
                return time && time.isSame(moment(scope.slice.dag), 'day');
            };

            agendaContextCtrl.addTimeChangedListener(scope, function (now) {
                time = now;
            });

            scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
                if (toState.name === fromState.name) {
                    scope.loading = true;
                }
            });
        }
    };
});

module.directive('moveTarget', function () {
    return {
        restrict: 'A',
        templateUrl: '/partials/components/move.target.html',
        scope: {
            currentSlice: '='
        },
        replace: false,

        controller: function ($scope, moveService, rasterService) {
            $scope.isMovingTargetToSlice = function () {
                return moveService.isMovingToSlice($scope.currentSlice);
            };

            $scope.calculateTargetTop = function () {
                return rasterService.calculateTop(moveService.getTarget());
            };

            var calculateHeight = function (event) {
                var duur = moment(event.tot, 'HH:mm').diff(moment(event.van, 'HH:mm'), 'minutes');
                return rasterService.getHeight({duur: duur});
            };

            $scope.calculateTargetHeight = function () {
                // TODO: fix this.
                return calculateHeight(moveService.getTarget());
            };
        }
    };
});

module.factory('EventHighlighter', function () {
    return {
        highlightEvent: highlightEvent
    }


    function highlightEvent(element) {

        const agendaEvent = element.find('.agenda-event');
        const agendaBody = $('.agenda-body');

        if (!agendaBody || !agendaEvent) {
            return;
        }

        scrollIntoView(agendaEvent, agendaBody);
        doHighlighting(agendaEvent, agendaBody);
    }

    function scrollIntoView(agendaEvent, agendaBody) {
        let $html = $('html, body');
        $html.scrollTop(agendaEvent.offset().top - agendaBody.offset().top - 160);
        $html.scrollLeft(agendaEvent.offset().left - agendaBody.offset().left - 40);
    }

    function doHighlighting(agendaEvent, agendaBody) {
        agendaBody.addClass("highlighted-agenda");
        agendaEvent.addClass("highlighted-event");
        window.setTimeout(() => agendaBody.removeClass("highlighted-agenda"), 2000);
        window.setTimeout(() => agendaEvent.removeClass("highlighted-event"), 2500);
    }
})


module.directive('popoverEvent', function (borderColor, rasterService, praktijkAfgewerkt, EventHighlighter) {
    return {
        require: '^agendaContext',
        restrict: 'A',
        templateUrl: '/partials/components/popover.event.html',
        scope: {
            event: '='
        },
        transclude: true,
        link: function ($scope, element, attrs, agendaContextCtrl) {
            $scope.rasterService = rasterService;
            $scope.clickedOnEvent = agendaContextCtrl.clickedOnEvent;
            $scope.dblClickedOnEvent = agendaContextCtrl.dblClickedOnEvent;
            $scope.praktijkAfgewerkt = praktijkAfgewerkt;

            $scope.maskOnHover = function () {
                return agendaContextCtrl.getActiveProfile().maskOnHover;
            };
            $scope.getBackgroundColor = function (event) {
                return agendaContextCtrl.isEventInFocus(event) ? borderColor(event.kleur) : event.kleur;
            };

            $scope.getBorderColor = function (kleur) {
                return borderColor(kleur);
            };

            $scope.$on('highlightEvent', function (event, eventId) {
                if ($scope.event.id === eventId || $scope.event.id.endsWith("afspraak/" + eventId)) {
                    EventHighlighter.highlightEvent(element);
                }
            });
        }
    };
});

module.directive('simpleEvent', function (borderColor, rasterService, EventHighlighter) {
    return {
        require: '^agendaContext',
        restrict: 'A',
        templateUrl: '/partials/components/simple.event.html',
        scope: {
            event: '='
        },
        transclude: true,
        link: function ($scope, element, attrs, agendaContextCtrl) {
            $scope.rasterService = rasterService;
            $scope.clickedOnEvent = agendaContextCtrl.clickedOnEvent;

            $scope.getBorderColor = function (kleur) {
                return borderColor(kleur);
            };

            $scope.$on('highlightEvent', function (event, eventId) {
                if ($scope.event.id === eventId || $scope.event.id.endsWith("afspraak/" + eventId)) {
                    EventHighlighter.highlightEvent(element);
                }
            });
        }
    };
});

module.directive('timeline', function (rasterService) {
    return {
        require: '^agendaContext',
        restrict: 'A',
        template: '<div class="timeline" ng-if="isVisible()" ng-style="{top: getPosition() + \'px\'}"><hr class="timeline-ruler"></div>',
        scope: {
            dag: '='
        },
        link: function ($scope, element, attrs, agendaContextCtrl) {
            var time;

            $scope.getPosition = function () {
                return time ? rasterService.calculateTopPixels(time.hours(), time.minutes()) : 0;
            };

            $scope.isVisible = function () {
                return time && time.isSame(moment($scope.dag), 'day') && (time.hours() >= rasterService.getStartUur() && time.hours() <= rasterService.getEindUur() - 1);
            };

            agendaContextCtrl.addTimeChangedListener($scope, function (now) {
                time = now;
            });
        }
    };
});

module.directive('timelinePill', function (slicesService, rasterService) {
    return {
        require: '^agendaContext',
        restrict: 'A',
        template: '<div class="timeline timeline-pill" ng-if="isVisible()" ng-style="{top: getPosition() - 9 + \'px\'}"><span class="label label-danger">{{getTime()}}</span></div>',
        scope: {
            dag: '='
        },
        link: function ($scope, element, attrs, agendaContextCtrl) {
            var time;

            $scope.getPosition = function () {
                return time ? rasterService.calculateTopPixels(time.hours(), time.minutes()) : 0;
            };

            $scope.isVisible = function () {
                var criteria = slicesService.slicesLoader.criteria;
                return time && time.isSame(moment(criteria.dag), criteria.modus === 'week' ? 'week' : 'day') && (time.hours() >= rasterService.getStartUur() && time.hours() <= rasterService.getEindUur() - 1);
            };

            $scope.getTime = function () {
                return time ? time.format('H:mm') : '';
            };

            agendaContextCtrl.addTimeChangedListener($scope, function (now) {
                time = now;
            });
        }
    };
});

module.directive('agendaheader', function () {
    return {
        templateUrl: '/partials/components/agendaheader.html',
        scope: {
            agendas: '=',
            slicesLoader: '=',
            agendaBoundaries: '='
        },
        link: function ($scope, $element, $attrs) {
            // TODO quick-fix omdat we agenda headers twee maal op zelfde agenda zetten, en willen voorkomen dat beide datasteppers in deze headers op key-up events luisteren...
            $scope.pusher = $attrs.hasOwnProperty('pusher');
        },
        controller: function ($scope, userContext, $uibModal, csvDownloader, pdfDownloader, wordDownloader) {
            $scope.userContext = userContext;
            $scope.exportCsv = function () {

                let modalInstance;

                let exportCsv = function () {
                    modalInstance.close();
                    $scope.slicesLoader.criteria.exportAgenda('csv')
                        .then(response => csvDownloader.download(response, "export"))
                }

                let exportPdf = function () {
                    modalInstance.close();
                    $scope.slicesLoader.criteria.exportAgenda('pdf')
                        .then(response => pdfDownloader.download(response, "export", 'datetime'))
                }

                let exportWord = function () {
                    modalInstance.close();
                    $scope.slicesLoader.criteria.exportAgenda('docx')
                        .then(response => wordDownloader.download(response, "export", 'datetime'))
                }

                $scope.confirmmodal = {
                    title: doclrVertaal.instant('components.agenda.exportcsv.confirmmodal.title'),
                    question: doclrVertaal.instant('components.agenda.exportcsv.confirmmodal.question'),
                    exportCsv: exportCsv,
                    exportPdf: exportPdf,
                    exportWord: exportWord
                }

                modalInstance = $uibModal.open({
                    templateUrl: '/partials/adminagenda/export.modal.html',
                    scope: $scope
                });

                modalInstance.result.then(() => {
                }, () => {
                });


            };
        }
    };
});

module.directive('agenda', function (slicesService, rasterService, appContext, $interval, $timeout, scrollerService) {
    return {
        restrict: 'A',
        templateUrl: '/partials/components/agenda.html',
        transclude: true,
        require: '^agendaContext',
        scope: {},
        controller: function ($scope, $attrs, $transclude, agendaBoundaries, moveService, praktijkContext, userContext) {
            this.renderEventTemplate = $transclude;
            $scope.praktijkContext = praktijkContext;
            $scope.userContext = userContext;
            $scope.markeerVolzetBezetSlices = $attrs.hasOwnProperty('markeerVolzetBezetSlices');
            $scope.showExtendControls = $attrs.hasOwnProperty('showExtendControls');

            $scope.agendaBoundaries = agendaBoundaries;
            $scope.rasterService = rasterService;

            $scope.copy = function (event) {
                moveService.start(event, true);
            };
        },
        link: {
            pre: function ($scope, element, attrs, agendaContextCtrl) {
                $scope.slicesLoader = slicesService.slicesLoader;
                $scope.agendas = agendaContextCtrl.agendas;

                var BATCH_SIZE = 3;
                var batchTimeout;
                $scope.renderLimit = BATCH_SIZE;

                function renderNextBatch(total) {
                    if ($scope.renderLimit >= total) return;
                    batchTimeout = $timeout(function () {
                        $scope.renderLimit = Math.min($scope.renderLimit + BATCH_SIZE, total);
                        renderNextBatch(total);
                    }, 0);
                }

                $scope.$watch('slicesLoader.sliceHolders.length', function (newLength) {
                    if (!newLength) return;
                    if (batchTimeout) $timeout.cancel(batchTimeout);
                    $scope.renderLimit = BATCH_SIZE;
                    renderNextBatch(newLength);
                });

                $scope.$on('highlightEvent', function (event, eventId) {
                    var total = $scope.slicesLoader.sliceHolders ? $scope.slicesLoader.sliceHolders.length : 0;
                    if ($scope.renderLimit < total) {
                        if (batchTimeout) $timeout.cancel(batchTimeout);
                        $scope.renderLimit = total;
                        $timeout(function () {
                            $scope.$broadcast('highlightEvent', eventId);
                        }, 0);
                    }
                });

                $scope.$on('$destroy', function () {
                    if (batchTimeout) $timeout.cancel(batchTimeout);
                });

                $scope.scrollLeft = function () {
                    scrollerService.scrollPageXBy(-200);
                }

                $scope.scrollRight = function () {
                    scrollerService.scrollPageXBy(200);
                }

                $scope.canScrollLeft = function () {
                    return scrollerService.getScrollXState().canLeft;
                }

                $scope.canScrollRight = function () {
                    return scrollerService.getScrollXState().canRight;
                }


                function showHoverLine() {
                    const body = document.getElementById('agendaBody');
                    const line = document.getElementById('hoverLine');

                    body.addEventListener('mouseenter', () => {
                        line.style.display = 'block';
                    });
                    body.addEventListener('mouseleave', () => {
                        line.style.display = 'none';
                    });

                    body.addEventListener('mousemove', (e) => {
                        const r = body.getBoundingClientRect();
                        const y = e.clientY - r.top + body.scrollTop; // if body itself scrolls vertically
                        line.style.top = `${y}px`;
                    });
                }

                function tagCalendarActive() {
                    if (appContext.brandingSettings.flexibleCalendarWidth && appContext.brandingSettings.flexibleCalendarWidth.hasFlexibleCalendarWidth) {
                        let root = angular.element(document.body);
                        root.addClass('main-agenda-flexible-active');
                        $scope.$on('$destroy', function () {
                            root.removeClass('main-agenda-flexible-active');
                        });
                    }
                }

                function updateScrollers() {
                    const leftScroller = $('#calendarScrollLeft');
                    const rightScroller = $('#calendarScrollRight');

                    if (!leftScroller || !rightScroller) return;

                    const scrollXState = scrollerService.getScrollXState();

                    leftScroller.toggleClass('can-scroll', scrollXState.canLeft);
                    rightScroller.toggleClass('can-scroll', scrollXState.canRight);

                }

                showHoverLine();
                tagCalendarActive();

                const stop = $interval(updateScrollers, 500);

                $scope.$on('$destroy', function () {
                    $interval.cancel(stop);
                });

            }
        }
    };
});

module.directive('renderEvent', function () {
    return {
        require: '^agenda',
        link: function (scope, element, attrs, agendaController) {
            agendaController.renderEventTemplate(scope, function (clone) {
                element.append(clone);
            });
        }
    };
});

module.directive('legende', function () {
    return {
        restrict: 'A',
        templateUrl: '/partials/components/legende.html',
        replace: true,
        scope: {},
        controller: function ($scope, borderColor, slicesService) {
            $scope.slicesLoader = slicesService.slicesLoader;

            $scope.borderColor = function (item) {
                return borderColor(item.kleur);
            };
        }
    };
});

module.directive('praktijkInfo', function () {
    return {
        template: '<p><strong>{{praktijk.naam}}</strong><br>{{praktijk.straat}} {{praktijk.nummer}} {{praktijk.bus}}<br>{{praktijk.postcode}} {{praktijk.gemeente}}<br>{{praktijk.telefoon}}</p>',
        scope: {
            praktijk: '='
        }
    };
});

module.directive('locationInfo', function () {
    return {
        template: '<p><strong>{{praktijk.naam}}</strong><br>{{location.straat}} {{location.nummer}} {{location.bus}}<br>{{location.postcode}} {{location.gemeente}}<br>{{location.telefoon}}</p>',
        scope: {
            praktijk: '=',
            location: '='
        }
    };
});

module.directive('reloadPeriodically', function (repeater, slicesService) {
    return {
        scope: false,
        link: function (scope) {
            repeater
                .repeat(function () {
                    slicesService.reload();
                })
                .limitTo(scope)
                .start();
        }
    };
});

module.directive('appointmentTypePicker', function () {
    return {
        restrict: 'E',
        scope: {
            availableTypes: '<',
            selectedType: '=',
            placeholder: '@'
        },
        templateUrl: '/partials/components/appointment.type.picker.html',
        controller: function ($scope, borderColor) {
            $scope.borderColor = function (type) {
                return borderColor(type.kleur);
            };

            $scope.selectOnSearch = function (type) {
                $scope.selectedType = type;
            }

            $scope.startSearch = function () {
                if ($scope.availableTypes < 2) {
                    return;
                }
                $scope.selectedType = undefined;
                window.setTimeout(x => {
                        const searchboxType = document.getElementById("searchboxType");
                        if (searchboxType) {
                            searchboxType.focus();
                        }
                    }, 20
                )
            }
        },
    };
});

module.directive('multiCalendarPicker', function () {
    return {
        restrict: 'E',
        scope: {
            multiCalendarSelection: '=',
            placeholder: '@',
            isReadOnly: '='
        },
        templateUrl: '/partials/components/multi.calendar.picker.html',
        controller: function ($scope, calendars, $timeout) {

            let shouldBlur = false;
            $scope.selectedCalendars = calendars.filter(c => $scope.multiCalendarSelection.calendarIds.indexOf(c.uuid) > -1);
            $scope.availableCalendars = calendars;

            $scope.onIsOpen = function (x) {
                console.log('onIsOpen: ' + x)
            }

            function checkBlur() {
                if (shouldBlur) {
                    $scope.safeApply(() => $scope.searching = false);
                }
            }

            function updateCalendars() {

                const filteredAgendas = calendars.filter(cal => {
                    return $scope.selectedCalendars.filter(sel => sel.uuid === cal.uuid).length === 0;
                });

                $scope.availableCalendars = [{uuid: 'xxx', naam: "Alle agenda's"}, ...filteredAgendas];

                let defaultSelectedCalendars = $scope.selectedCalendars
                    .filter(x => x.uuid === $scope.multiCalendarSelection.defaultCalendarId)
                    .sort((a, b) => a.naam.localeCompare(b.naam));

                let otherSelectedCalendars = $scope.selectedCalendars
                    .filter(x => x.uuid !== $scope.multiCalendarSelection.defaultCalendarId)
                    .sort((a, b) => a.naam.localeCompare(b.naam));

                $scope.selectedCalendars = [...defaultSelectedCalendars, ...otherSelectedCalendars]

                $scope.multiCalendarSelection.calendarIds = $scope.selectedCalendars.map(x => x.uuid);

            }

            $scope.safeApply = function (fn) {
                var phase = this.$root.$$phase;
                if (phase == '$apply' || phase == '$digest') {
                    if (fn && (typeof (fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$apply(fn);
                }
            };

            $scope.selectOnSearch = function (calendar) {

                if ($scope.isReadOnly) {
                    return;
                }

                if (calendar.uuid === "xxx") {
                    $scope.multiCalendarSelection.forAllCalendars = true;
                    $scope.searching = false;
                    return;
                }

                $scope.selectedCalendars.push(calendar);
                updateCalendars();
                shouldBlur = false;
                if ($scope.availableCalendars.length === 1) {
                    $scope.searching = false;
                }

            }

            $scope.onBlurSearch = function () {
                shouldBlur = true;
                window.setTimeout(() => checkBlur(), 300);
            }

            $scope.unselectForAll = function () {
                if ($scope.isReadOnly) {
                    return;
                }

                $scope.multiCalendarSelection.forAllCalendars = false;
            }

            $scope.removeCalendar = function (calendar) {

                if ($scope.isReadOnly) {
                    return;
                }

                if ($scope.selectedCalendars.length === 1) {
                    return
                }

                if ($scope.multiCalendarSelection.defaultCalendarId === calendar.id) {
                    return;
                }

                $scope.selectedCalendars = $scope.selectedCalendars.filter(x => x.id !== calendar.id);
                updateCalendars();
            }


            $scope.startSearch = function () {
                if ($scope.availableCalendars < 2) {
                    return;
                }

                $scope.searching = true;
                $scope.selectedCalendar = undefined;
                $timeout(x => {
                        const searchboxType = document.getElementById("searchboxCalendar");
                        if (searchboxType) {
                            searchboxType.focus();
                        }
                    }, 20
                )
            }

            updateCalendars();
        },
    };
});